import React from "react";
import { Button } from "@material-ui/core";

import Modal from "../../Modal";

import styles from "./AddAlarmIdModalPrompt.module.scss";

const AddAlarmIdModalPrompt = ({ onClosePrompt, openAddAlarmIdFormModal, IsUserHasNotEnteredAllData }) => {

    const handleClick = () => {
        onClosePrompt();
        openAddAlarmIdFormModal();
    }

    return (
        <Modal>
            <div className={styles.modalContent} style={{ width: "35vw", padding: '30px 50px' }}>
                <div className={styles.modalHeader}>
                    <div className={styles.modalHeaderRow}>
                        <div className={styles.prompt_text}>
                            {IsUserHasNotEnteredAllData
                                ? (
                                    <>
                                        <h2>You have not entered all the data.</h2>
                                        <div className={styles.asking_text}>Do you want to add all information?</div>
                                    </>
                                )
                                : (
                                    <>
                                        <h2>This event has not been downloaded from the device.</h2>
                                        <div className={styles.asking_text}>Do you want to download the alarm?</div>
                                    </>
                                )
                            }
                        </div>
                        <button onClick={onClosePrompt} role="close modal button">X</button>
                    </div>
                </div>
                <hr />

                <div className={styles.buttons_block}>
                    <Button
                        type={'button'}
                        variant="contained"
                        onClick={handleClick}
                    >
                        {IsUserHasNotEnteredAllData ? "Yes, add all information" : "Yes, download the alarm"}
                    </Button>
                    <Button
                        type={'button'}
                        variant="outlined"
                        onClick={onClosePrompt}
                    >
                        Cancel
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default AddAlarmIdModalPrompt;
